import type { IssueTypeId } from '@atlassian/jira-shared-types';
import { getIssueType } from '../configuration/selectors';
import type { State } from '../types';

export const getIssueTypeName = (state: State, issueTypeId: IssueTypeId): string =>
	getIssueType(state, issueTypeId).name;
